if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          if (!activeMedia.getAttribute('loaded')) activeMedia.loadContent();
          const video = activeMedia.querySelector('video');
          if (video) video.play().catch(() => {});
        }
      }
    }
  );
}

if (!customElements.get('poster-modal-opener')) {
  customElements.define(
    'poster-modal-opener',
    class PosterModalOpener extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(e) {
        const poster = e.target.closest('.deferred-media__poster');
        if (!poster) return;

        const deferredMedia = poster.closest('.deferred-media') || poster.closest('product-model');
        if (!deferredMedia) return;

        const mediaId = deferredMedia.getAttribute('data-media-id');
        const button = this.previousElementSibling?.querySelector(`button[data-media-id="${mediaId}"]`);
        if (!button) return;

        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (!modal?.show) return;

        e.preventDefault();
        e.stopPropagation();
        modal.show(button);
      }
    }
  );
}
